import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getWarehouseApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getWarehouseListApi = createAsyncThunk('getWarehouseList', async (payload) => {
  // console.log('payload', payload);
  return await getWarehouseApi(payload);
});

const getWarehouseListSlice = createSlice({
  name: 'getWarehouseList', // Unique Name
  initialState,
  reducers: {
    getWarehouseListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWarehouseListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getWarehouseListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getWarehouseListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getWarehouseListReset } = getWarehouseListSlice.actions;

export default getWarehouseListSlice.reducer;
